/*
 * Copyright (c) 2021. Datafood srl
 * Developed by Revo Digital - revodigital.it
 * ---
 * Author: leonardoviada
 * File: LoginForm.tsx
 * Project: mle-client
 * Committed last: 2021/11/2 @ 177
 * ---
 */

import { Form, Formik }           from 'formik';
import React                      from 'react';
import * as Yup                   from 'yup';
import { defaultRequiredMessage } from '../../config/content';
import { Button }                 from '@blueprintjs/core';
import { BpTextFieldWrapper }     from './wrappers/BpTextFieldWrapper';
import { BpPasswordFieldWrapper } from './wrappers/BpPasswordFieldWrapper';
import { DefaultFormProps }       from '../../common/interfaces';

const LoginFormValidationSchema = Yup.object().shape({
  email: Yup.string().email().required(defaultRequiredMessage),
  password: Yup.string().required(defaultRequiredMessage)
});

export interface LoginFormValues {
  email: string;
  password: string;
}

export const LoginForm = (props: DefaultFormProps) => {
  return (
    <Formik
      initialValues={ {} }
      validationSchema={ LoginFormValidationSchema }
      onSubmit={ props.onSubmit }
    >
      { ({ isSubmitting }) => (
        <Form>
          <BpTextFieldWrapper name="email" label="Email" type="email"
                              required/>
          <BpPasswordFieldWrapper name="password" label="Password"
                                  required/>
          <div className="mle-form-submit">
            <Button intent="primary" type="submit" className="w-full"
                    loading={ isSubmitting }>
              Accedi
            </Button>
          </div>
        </Form>
      ) }
    </Formik>
  );
};
